/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const REST_STORE = "REST_STORE";

/* SETTINGS */
export const CHANGE_DATE_START = "CHANGE_DATE_START";
export const CHANGE_DATE_END = "CHANGE_DATE_END";
export const CLEAR_FILTER_ALL = "CLEAR_FILTER_ALL";
export const SESSION_ACCESS_DENIED = "SESSION_ACCESS_DENIED";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
	"MENU_CHANGE_HAS_SUB_ITEM_STATUS";

export const MENU_FETCH = "MENU_FETCH";
export const MENU_FETCH_SUCCESS = "MENU_FETCH_SUCCESS";
export const MENU_FETCH_FAIL = "MENU_FETCH_FAIL";

export const MENU_STATE = "MENU_STATE";

/* PAYMENT */
export const TRANSACTION_FETCH = "TRANSACTION_FETCH";
export const TRANSACTION_FETCH_SUCCESS = "TRANSACTION_FETCH_SUCCESS";
export const TRANSACTION_FETCH_FAIL = "TRANSACTION_FETCH_FAIL";
export const TRANSACTION_MONTHLY_FETCH = "TRANSACTION_MONTHLY_FETCH";
export const TRANSACTION_MONTHLY_FETCH_SUCCESS = "TRANSACTION_MONTHLY_FETCH_SUCCESS";
export const TRANSACTION_MONTHLY_FETCH_FAIL = "TRANSACTION_MONTHLY_FETCH_FAIL";
export const TRANSACTION_SUMMARY_FETCH = "TRANSACTION_SUMMARY_FETCH";
export const TRANSACTION_SUMMARY_FETCH_SUCCESS = "TRANSACTION_SUMMARY_FETCH_SUCCESS";
export const TRANSACTION_SUMMARY_FETCH_FAIL = "TRANSACTION_SUMMARY_FETCH_FAIL";
export const TRANSACTION_MACHINETYPE_FETCH = "TRANSACTION_MACHINETYPE_FETCH";
export const TRANSACTION_MACHINETYPE_FETCH_SUCCESS = "TRANSACTION_MACHINETYPE_FETCH_SUCCESS";
export const TRANSACTION_MACHINETYPE_FETCH_FAIL = "TRANSACTION_MACHINETYPE_FETCH_FAIL";
export const TRANSACTION_CONFIRMATION_FETCH = "TRANSACTION_CONFIRMATION_FETCH";
export const TRANSACTION_CONFIRMATION_FETCH_SUCCESS = "TRANSACTION_CONFIRMATION_FETCH_SUCCESS";
export const TRANSACTION_CONFIRMATION_FETCH_FAIL = "TRANSACTION_CONFIRMATION_FETCH_FAIL";
export const TRANSACTION_BY_SERVICE_FETCH = "TRANSACTION_BY_SERVICE_FETCH";
export const TRANSACTION_BY_SERVICE_FETCH_SUCCESS = "TRANSACTION_BY_SERVICE_FETCH_SUCCESS";
export const TRANSACTION_BY_SERVICE_FETCH_FAIL = "TRANSACTION_BY_SERVICE_FETCH_FAIL";
/* device */
export const DEVICE_SUMMARY_FETCH = "DEVICE_SUMMARY_FETCH";
export const DEVICE_SUMMARY_FETCH_SUCCESS = "DEVICE_SUMMARY_FETCH_SUCCESS";
export const DEVICE_SUMMARY_FETCH_FAIL = "DEVICE_SUMMARY_FETCH_FAIL";

export const DEVICE_FETCH = "DEVICE_FETCH";
export const DEVICE_FETCH_SUCCESS = "DEVICE_FETCH_SUCCESS";
export const DEVICE_FETCH_FAIL = "DEVICE_FETCH_FAIL";

export const MACHINE_TYPE_FETCH = "MACHINE_TYPE_FETCH";
export const MACHINE_TYPE_FETCH_SUCCESS = "MACHINE_TYPE_FETCH_SUCCESS";
export const MACHINE_TYPE_FETCH_FAIL = "MACHINE_TYPE_FETCH_FAIL";

export const CREATE_NEW_MACHINE = "CREATE_NEW_MACHINE";
export const CREATE_NEW_MACHINE_SUCCESS = "CREATE_NEW_MACHINE_SUCCESS";
export const CREATE_NEW_MACHINE_FAIL = "CREATE_NEW_MACHINE_FAIL";

export const DEVICE_DETAIL_FETCH = "DEVICE_DETAIL_FETCH";
export const DEVICE_DETAIL_FETCH_SUCCESS = "DEVICE_DETAIL_FETCH_SUCCESS";
export const DEVICE_DETAIL_FETCH_FAIL = "DEVICE_DETAIL_FETCH_FAIL";

export const DEVICE_ONOFFLINE_FETCH = "DEVICE_ONOFFLINE_FETCH";
export const DEVICE_ONOFFLINE_FETCH_SUCCESS = "DEVICE_ONOFFLINE_FETCH_SUCCESS";
export const DEVICE_ONOFFLINE_FETCH_FAIL = "DEVICE_ONOFFLINE_FETCH_FAIL";

//wait for develop
export const EDIT_MACHINE = "EDIT_MACHINE";
export const EDIT_MACHINE_SUCCESS = "EDIT_MACHINE_SUCCESS";
export const EDIT_MACHINE_FAIL = "EDIT_MACHINE_FAIL";

//wait for develop
export const UPDATE_DEVICE_PROFILE = "UPDATE_DEVICE_PROFILE";
export const UPDATE_DEVICE_PROFILE_SUCCESS = "UPDATE_DEVICE_PROFILE_SUCCESS";
export const UPDATE_DEVICE_PROFILE_FAIL = "UPDATE_DEVICE_PROFILE";

/* merchant */
export const MERCHANT_FETCH = "MERCHANT_FETCH";
export const MERCHANT_FETCH_SUCCESS = "MERCHANT_FETCH_SUCCESS";
export const MERCHANT_FETCH_FAIL = "MERCHANT_FETCH_FAIL";
export const CHANGE_SELECT_MERCHANT = "CHANGE_SELECT_MERCHANT";
export const CLEAR_SELECT_MERCHANT = "CLEAR_SELECT_MERCHANT";
export const MERCHANT_SUMMARY_FETCH = "MERCHANT_SUMMARY_FETCH";
export const MERCHANT_SUMMARY_FETCH_SUCCESS = "MERCHANT_SUMMARY_FETCH_SUCCESS";
export const MERCHANT_SUMMARY_FETCH_FAIL = "MERCHANT_SUMMARY_FETCH_FAIL";

export * from "./menu/actions";
export * from "./settings/actions";
export * from "./auth/actions";
export * from "./payment/actions";
export * from "./common/actions";
export * from "./device/actions";
